import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = 'https://golf-reservation-backend.onrender.com';

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email) return setError('이메일을 입력해주세요');
    setLoading(true);
    setError('');

    try {
      const { data: users } = await axios.get(`${API}/users`);
      const user = users.find(u => u.email === email);

      if (!user) {
        setError('등록되지 않은 이메일이에요. 관리자에게 문의하세요.');
        setLoading(false);
        return;
      }

      localStorage.setItem('golf_user', JSON.stringify(user));
      onLogin(user);

      if (user.role === 'executive') navigate('/executive');
      else if (user.role === 'secretary') navigate('/secretary');
      else setError('접근 권한이 없어요.');
    } catch (e) {
      setError('서버 연결에 실패했어요. 잠시 후 다시 시도해주세요.');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* 상단 로고 영역 */}
        <div style={styles.logoArea}>
          <img src="/logo.png" alt="AP Group" style={styles.companyLogo} />
        </div>

        {/* 구분선 */}
        <div style={styles.divider} />

        {/* 타이틀 */}
        <div style={styles.titleArea}>
          <span style={styles.golfIcon}>⛳</span>
          <h1 style={styles.title}>골프 예약 시스템</h1>
        </div>

        {/* 로그인 폼 */}
        <div style={styles.form}>
          <label style={styles.label}>이메일</label>
          <input
            style={styles.input}
            type="email"
            placeholder="이메일 주소를 입력해주세요"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
          />
          {error && <p style={styles.error}>{error}</p>}
          <button
            style={{ ...styles.button, opacity: loading ? 0.7 : 1 }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? '확인 중...' : '로그인'}
          </button>
        </div>
      </div>

      {/* 하단 크레딧 */}
      <p style={styles.credit}>Created by Phil (With Claude) 2026.</p>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f6f8',
    position: 'relative',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '40px 40px 36px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
  },
  logoArea: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  companyLogo: {
    height: '36px',
    objectFit: 'contain',
  },
  divider: {
    height: '1px',
    backgroundColor: '#f0f0f0',
    marginBottom: '28px',
  },
  titleArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '28px',
  },
  golfIcon: {
    fontSize: '28px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#1a1a1a',
    letterSpacing: '-0.3px',
  },
  form: {
    textAlign: 'left',
  },
  label: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#444',
    display: 'block',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '13px 14px',
    border: '1.5px solid #e5e7eb',
    borderRadius: '10px',
    fontSize: '15px',
    outline: 'none',
    marginBottom: '14px',
    color: '#1a1a1a',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
  },
  error: {
    color: '#e53e3e',
    fontSize: '13px',
    marginBottom: '12px',
    marginTop: '-6px',
  },
  button: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#2d6a4f',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    letterSpacing: '0.3px',
  },
  credit: {
    position: 'fixed',
    bottom: '16px',
    right: '20px',
    fontSize: '11px',
    color: '#c8c8c8',
    userSelect: 'none',
  },
};
